import React, { useState } from 'react';
import '../contactform.css';
import '../mysass.scss';
import {
  MDBCardBody,
  MDBCardTitle,
  MDBCardText,
  MDBRow,
  MDBCol
} from 'mdb-react-ui-kit';
import { Carousel,Card,Button } from 'react-bootstrap';



function ContactForm() {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log('Të dhënat e formularit:', name, email, message);
    // Këtu mund të dërgoni të dhënat e formularit në server ose kryeni veprime të tjera
  };

  return (

    <>
<br></br>
<br></br>
<div id='contact' className='anchorscontact' style={{textAlign:'center',fontSize:'16px'}}>
     If you decide to stay in <b>KOSOVO</b>, please <b>Contact us</b> and we can help you with:
    </div>

    {/* <br></br> */}


<MDBRow className='m-1 row-cols-1 row-cols-md-3 g-4'>


<MDBCol>
            <Card className="bg-dark text-white">
          <Carousel interval={5000} fade style={{height:'500px'}} >
            
      <Carousel.Item>
      <Card.Img className='natureimages' src="emerald1.jpg" alt="Card image" />
      <Card.ImgOverlay style={{textAlign:'center'}}>
      <Button className='naturebutton' variant="outline-light" size="lg" style={{fontWeight:'500'}}>HOTELS</Button>
      </Card.ImgOverlay>
      <MDBCardBody>
            <MDBCardTitle>Emerald Hotel</MDBCardTitle>
            <MDBCardText style={{fontSize:'14px'}}>
              <b>Address:</b> <br></br>Magjistralja Prishtinë - Ferizaj, km. i 5-të, Prishtinë 10000 Kosovë
              <br></br>
              <b>Contact:</b>
              <br></br>
              reservation@emeraldhotel.info
              <br></br>
              +383 (0) 38 588 888      
            </MDBCardText>
          </MDBCardBody>
      </Carousel.Item>
      
      
      <Carousel.Item >
      <Card.Img className='natureimages' src="swiss.jpg" alt="Card image"  />
      <Card.ImgOverlay style={{textAlign:'center'}}>
      <Button className='naturebutton' variant="outline-light" size="lg" style={{fontWeight:'500'}}>HOTELS</Button>
      </Card.ImgOverlay>
      <MDBCardBody>
            <MDBCardTitle>Swiss Diamond Hotel</MDBCardTitle>
            <MDBCardText style={{fontSize:'14px'}}>
            <b>Address:</b> <br></br>Boulevard Mother Teresa N.N. - 10000 Pristina, Kosovo
              <br></br>
              <b>Contact:</b>
              <br></br>
              reservations@sdhprishtina.com
              <br></br>
              +383 38 220 000             
            </MDBCardText>
          </MDBCardBody>
      </Carousel.Item>

      <Carousel.Item >
      <Card.Img className='natureimages' src="premiumpark.jpg" alt="Card image"  />
      <Card.ImgOverlay style={{textAlign:'center'}}>
      <Button className='naturebutton' variant="outline-light" size="lg" style={{fontWeight:'500'}}>HOTELS</Button>
      </Card.ImgOverlay>
      <MDBCardBody>
            <MDBCardTitle>Premium Park Hotel</MDBCardTitle>
            <MDBCardText style={{fontSize:'14px'}}>
            <b>Address:</b> <br></br>Rr. Tirana NN, 20000 Prizren, Kosovo
              <br></br>
              <b>Contact:</b>
              <br></br>
              +383 29 222 444
              <br></br>
              +383 43 504 504
              </MDBCardText>
          </MDBCardBody>
      </Carousel.Item>

    </Carousel>
    </Card>
      </MDBCol>


      <MDBCol>
            <Card className="bg-dark text-white">
          <Carousel interval={5000} fade style={{height:'500px'}} >
      <Carousel.Item>
      <Card.Img className='natureimages' src="sixt.jpg" alt="Card image" style={{backgroundColor:'white'}} />
      <Card.ImgOverlay style={{textAlign:'center'}}>
      <Button className='naturebutton' variant="outline-dark" size="lg" style={{fontWeight:'500'}}>RENTAL CAR</Button>
      </Card.ImgOverlay>
      <MDBCardBody>
            <MDBCardTitle>SiXT</MDBCardTitle>
            <MDBCardText style={{fontSize:'14px'}}>
            <b>Address:</b> <br></br>Qendra Tregtare Albi Mall, Pristina, PR,
              <br></br>
              Rruga Dardania pn, Kosovo Polje, PR,
              <br></br>
              Rruga e Aeroportit, Pristina, PR
              <br></br>
              <b>Contact:</b>
              <br></br>
              +383 45 669 668       
            </MDBCardText>
          </MDBCardBody>
      </Carousel.Item>
      
      
      <Carousel.Item >
      <Card.Img className='natureimages' src="enterprise.jpg" alt="Card image"  />
      <Card.ImgOverlay style={{textAlign:'center'}}>
      <Button className='naturebutton' variant="outline-dark" size="lg" style={{fontWeight:'500'}}>REANTAL CAR</Button>
      </Card.ImgOverlay>
      <MDBCardBody>
            <MDBCardTitle>Enterprise</MDBCardTitle>
            <MDBCardText style={{fontSize:'14px'}}>
            <b>Address:</b> <br></br>Deshmoret E KombitKosovo, Uroshevac, FE,
              <br></br>
              Pristina Airport "Adem Jashari" Pristina, Kosovo,
              <br></br>
              QagliaviceKosovo, Pristina, PR
              <br></br>
              <b>Contact:</b>
              <br></br>
              +386 49 144 443              
              </MDBCardText>
          </MDBCardBody>
      </Carousel.Item>

      <Carousel.Item >
      <Card.Img className='natureimages' src="europcar.jpg" alt="Card image"  />
      <Card.ImgOverlay style={{textAlign:'center'}}>
      <Button className='naturebutton' variant="outline-dark" size="lg" style={{fontWeight:'500'}}>REANTAL CAR</Button>
      </Card.ImgOverlay>
      <MDBCardBody>
            <MDBCardTitle>Enterprise</MDBCardTitle>
            <MDBCardText style={{fontSize:'14px'}}>
            <b>Address:</b> <br></br>Rr.jusuf Gervalla Nr. 30Main Road Prishtine-Mitrovice,
              <br></br>
              Vrelle Lipjan, Pristina, PR              
              
              <br></br>
              <b>Contact:</b>
              <br></br>
              +383 44 116 746             
              </MDBCardText>
          </MDBCardBody>
      </Carousel.Item>
    </Carousel>
    </Card>
      </MDBCol>


      <MDBCol>
            <Card className="bg-dark text-white">
          <Carousel interval={5000} fade style={{height:'500px'}} >
      <Carousel.Item>
      <Card.Img className='natureimages' src="bank1.jpg" alt="Card image" />
      <Card.ImgOverlay style={{textAlign:'center'}}>
      <Button className='naturebutton' variant="outline-dark" size="lg" style={{fontWeight:'500'}}>CURRENCY EXCHANGE</Button>
      </Card.ImgOverlay>
      <MDBCardBody>
            <MDBCardTitle>Raiffeisen Bank</MDBCardTitle>
            <MDBCardText style={{fontSize:'14px'}}>
            <b>Address:</b> <br></br>Rr. Agim Ramadani nr.15, Prishtine,
              <br></br>
              Rr. Robert Doll p.n, Prishtine,
              <br></br>
              Rr. Gazmend Zajmi N.N, Prishtine
              <br></br>
              <b>Contact:</b>
              <br></br>
              +383 49 222 222              
              </MDBCardText>
          </MDBCardBody>
      </Carousel.Item>
      
      
      <Carousel.Item >
      <Card.Img className='natureimages' src="bank2.jpg" alt="Card image"  />
      <Card.ImgOverlay style={{textAlign:'center'}}>
      <Button className='naturebutton' variant="outline-dark" size="lg" style={{fontWeight:'500'}}>CURRENCY EXCHANGE</Button>
      </Card.ImgOverlay>
      <MDBCardBody>
            <MDBCardTitle>MoneyGram</MDBCardTitle>
            <MDBCardText style={{fontSize:'14px'}}>
            <b>Address:</b> <br></br>Prishtinë 10060, Kosovë,
              <br></br>
              Ndërtesa Illyria, Rruga Prishtinë – Graçanicë,
              <br></br>
              <b>Contact:</b>
              <br></br>
              +383 44 602 102              
              </MDBCardText>
          </MDBCardBody>
      </Carousel.Item>

      <Carousel.Item >
      <Card.Img className='natureimages' src="bank3.jpg" alt="Card image"  />
      <Card.ImgOverlay style={{textAlign:'center'}}>
      <Button className='naturebutton' variant="outline-dark" size="lg" style={{fontWeight:'500'}}>CURRENCY EXCHANGE</Button>
      </Card.ImgOverlay>
      <MDBCardBody>
            <MDBCardTitle>EXcoin</MDBCardTitle>
            <MDBCardText style={{fontSize:'14px'}}>
            <b>Address:</b> <br></br>Tophane Branch Str. Vushtria, 14, 10000 Prishtine,
              <br></br>
              Ulpiana Branch Str. Zija Shemsiu, 25, 10000 Prishtine,
              <br></br>
              <b>Contact:</b>
              <br></br>
              +383 44 900 464               
              </MDBCardText>
          </MDBCardBody>
      </Carousel.Item>
    </Carousel>
    </Card>
      </MDBCol>



{/* ë */}
</MDBRow>




    <div  className="contact-form-container" >
      <h2 style={{textAlign:'center'}}>Contact Us </h2>
      <form onSubmit={handleSubmit}>
        <div className="form-group">
          <label htmlFor="name">Full Name</label>
          <input
            type="text"
            id="name"
            value={name}
            onChange={(e) => setName(e.target.value)}
            required
          />
        </div>
        <div className="form-group">
          <label htmlFor="email">Email</label>
          <input
            type="email"
            id="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
        </div>
        <div className="form-group">
          <label htmlFor="message">Message</label>
          <textarea
            id="message"
            value={message}
            onChange={(e) => setMessage(e.target.value)}
            required
          />
        </div>
        <button type="submit">Send</button>
      </form>
    </div>


    


    </>

  );
}

export default ContactForm;

